import React from 'react';

import Note from './Components/Note';
import Validation from './Components/Validation'
import Position from './Components/Position';
import CancelEdit from './Components/CancelEdit';

export default function PainScaleProperties({ question, position }) {
  return <>
    <p><strong>Question {question.linkId}:</strong> {question.text}</p>

    <Note question={question} />

    <Validation question={question} />

    <Position question={question} position={position} />

    <CancelEdit />
  </>
};